import Icon from '../components/Icon.vue'

Icon.register({
  hryvnia: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M368 240C376.8 240 384 232.8 384 224V192C384 183.2 376.8 176 368 176H326.1C339.6 147.4 339.9 112.7 322 81.9 303.3 49.8 267.1 32 230 32H151.1C126.8 32 103.3 40.5 84.6 56.1L72.8 65.9C62.6 74.4 61.3 89.5 69.8 99.7L90.3 124.3C98.7 134.5 113.9 135.9 124.1 127.4L135.8 117.6C140.1 114 145.6 112 151.2 112H234.8C246.5 112 256 121.5 256 133.2 256 139.1 253.5 144.8 249.2 148.8L219.7 176H16C7.2 176 0 183.2 0 192V224C0 232.8 7.2 240 16 240H150.4L115.7 272H16C7.2 272 0 279.2 0 288V320C0 328.8 7.2 336 16 336H57.9C44.5 364.6 44.1 399.3 62 430.1 80.7 462.1 116.9 480 154 480H232.9C257.2 480 280.7 471.5 299.4 455.9L311.2 446.1C321.4 437.6 322.7 422.5 314.2 412.3L293.8 387.7C285.3 377.5 270.1 376.1 259.9 384.6L248.2 394.4A24-24 0 0 0 232.8 400H149.2C137.5 400 128 390.5 128 378.8 128 372.9 130.5 367.2 134.8 363.2L164.3 336H368C376.8 336 384 328.8 384 320V288C384 279.2 376.8 272 368 272H233.6L268.3 240H368z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hryvnia.js
// module id = 3JRD
// module chunks = 144